@if (visible()) {
  <nav class="admin-nav" aria-label="Navegación de administración">
    <p class="admin-nav__title"><i class="pi pi-shield" aria-hidden="true"></i> Administración</p>
    <ul class="admin-nav__list">
      @for (seccion of secciones(); track seccion.id) {
        <li class="admin-nav__section" [class.is-current]="seccionActual(seccion)">
          <a
            class="admin-nav__link admin-nav__link--section"
            [routerLink]="seccion.route"
            [class.is-active]="activo() === seccion.route"
            [attr.aria-current]="activo() === seccion.route ? 'page' : null"
          >
            <i [class]="seccion.icon" aria-hidden="true"></i><span>{{ seccion.label }}</span>
          </a>
          @if (seccion.items.length) {
            <ul class="admin-nav__sub">
              @for (item of seccion.items; track item.route) {
                <li>
                  <a
                    class="admin-nav__link"
                    [routerLink]="item.route"
                    [class.is-active]="activo() === item.route"
                    [attr.aria-current]="activo() === item.route ? 'page' : null"
                  >
                    <i [class]="item.icon" aria-hidden="true"></i><span>{{ item.label }}</span>
                  </a>
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
    <a class="admin-nav__site" routerLink="/home"><i class="pi pi-external-link" aria-hidden="true"></i><span>Ver sitio público</span></a>
  </nav>
}
